import { motion } from "motion/react";
import type { PropsWithChildren } from "react";

type ExpandCollapseButtonProps = PropsWithChildren & {
	showElement: boolean;
};

export const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({
	showElement,
	children,
}) => {
	return (
		<motion.div
			initial={{ scale: 1 }}
			animate={{
				scale: showElement ? 1 : 0,
				transition: { duration: 0.3 },
			}}
			style={{
				position: "fixed",
				bottom: 40,
				right: 40,
				zIndex: 3,
			}}
		>
			{children}
		</motion.div>
	);
};
